import { Box } from "@mui/material";
import { Pagination, CompanyStamp } from "@/organism";
import { CompanyStampListItemDto } from "@/dto/CompanyStampDto";
import useList from "./useList";
import { SubscriptionProductSelectionDto } from "@/dto/SubscriptionDto";
import { TemplateSelectionDto } from "@/dto/TemplatesDto";

export type ListProps = {
  page: number;
  count: number;
  list: CompanyStampListItemDto[];
  isLoading?: boolean;
  subscriptionProductList: SubscriptionProductSelectionDto[];
  templateList: TemplateSelectionDto[];
};

export const List = (props: ListProps) => {
  const {
    page,
    count,
    list,
    isLoading,
    subscriptionProductList,
    templateList,
  } = props;
  const {
    rowsPerPage,
    handleDetail,
    handlePageChange,
    handleRowsPerPageChange,
    handleSearch,
    handleReset,
    companyStampRequest,
  } = useList();

  return (
    <Box display={"flex"} flexDirection={"column"} gap={2}>
      <CompanyStamp.Filter
        onChange={handleSearch}
        onReset={handleReset}
        values={companyStampRequest}
        subscriptionProductList={subscriptionProductList}
        templateList={templateList}
      />
      <CompanyStamp.List
        list={list}
        onDetail={handleDetail}
        isLoading={isLoading}
      />
      {count > 0 && (
        <Pagination
          count={count}
          page={page - 1}
          onPageChange={handlePageChange}
          onRowsPerPageChange={handleRowsPerPageChange}
          rowsPerPage={rowsPerPage}
        />
      )}
    </Box>
  );
};
